import React from "react";
import { Icon } from "react-icons-kit";

export default function IconWrapper({ icon }) {
  return <Icon icon={icon} />;
}
